import React from "react";
import { ReactComponent as BandSvg } from "../../../images/band-icon.svg";
import { ReactComponent as DiscoverSvg } from "../../../images/discover-tab-marker.svg";
import { ReactComponent as EventSvg } from "../../../images/event-icon.svg";
import { ReactComponent as FeedSvg } from "../../../images/feed-icon.svg";
import { ReactComponent as HomeSvg } from "../../../images/home-tab-icon.svg";
import { ReactComponent as PeopleSvg } from "../../../images/people-icon.svg";
import { ReactComponent as MessagesSvg } from "../../../images/messages-icon.svg";
import { ReactComponent as VenueSvg } from "../../../images/venue-icon.svg";
import {
    BANDS_TAB_ID,
    BILLING_TAB_ID,
    CHAT_TAB_ID,
    DISCOVER_TAB_ID,
    EVENTS_TAB_ID,
    FEED_TAB_ID,
    FRIENDS_TAB_ID,
    HOME_TAB_ID,
    SYSTEM_HEALTH_TAB_ID,
    VENUE_TAB_ID,
} from "../../../constants/MainNavigationTabSpecs";

const DEFAULT_ICON_SIZE = 20;
const DEFAULT_STROKE_WIDTH = 1.5;

const baseProps = {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    focusable: "false",
};

function createIcon(path) {
    return function Icon({ size = DEFAULT_ICON_SIZE, strokeWidth = DEFAULT_STROKE_WIDTH, ...props }) {
        return (
            <svg
                {...baseProps}
                width={size}
                height={size}
                strokeWidth={strokeWidth}
                aria-hidden={props["aria-label"] ? undefined : true}
                {...props}
            >
                {path}
            </svg>
        );
    };
}

export function HomeIcon({ size = DEFAULT_ICON_SIZE, style, ...props }) {
    return (
        <HomeSvg
            width={size}
            height={size}
            focusable="false"
            aria-hidden={props["aria-label"] ? undefined : true}
            style={{
                color: "currentColor",
                ...style,
            }}
            {...props}
        />
    );
}

export function FeedIcon({ size = DEFAULT_ICON_SIZE, style, ...props }) {
    return (
        <FeedSvg
            width={size}
            height={size}
            focusable="false"
            aria-hidden={props["aria-label"] ? undefined : true}
            style={{
                color: "currentColor",
                ...style,
            }}
            {...props}
        />
    );
}

export function PeopleIcon({ size = DEFAULT_ICON_SIZE, style, ...props }) {
    return (
        <PeopleSvg
            width={size}
            height={size}
            focusable="false"
            aria-hidden={props["aria-label"] ? undefined : true}
            style={{
                color: "currentColor",
                ...style,
            }}
            {...props}
        />
    );
}

export function EventIcon({ size = DEFAULT_ICON_SIZE, style, ...props }) {
    return (
        <EventSvg
            width={size}
            height={size}
            focusable="false"
            aria-hidden={props["aria-label"] ? undefined : true}
            style={{
                fill: "currentColor",
                ...style,
            }}
            {...props}
        />
    );
}

export function VenueIcon({ size = DEFAULT_ICON_SIZE, style, ...props }) {
    return (
        <VenueSvg
            width={size}
            height={size}
            focusable="false"
            aria-hidden={props["aria-label"] ? undefined : true}
            style={{
                color: "currentColor",
                ...style,
            }}
            {...props}
        />
    );
}

export function MessagesIcon({ size = DEFAULT_ICON_SIZE, style, ...props }) {
    return (
        <MessagesSvg
            width={size}
            height={size}
            focusable="false"
            aria-hidden={props["aria-label"] ? undefined : true}
            style={{
                color: "currentColor",
                ...style,
            }}
            {...props}
        />
    );
}

export function BandsIcon({ size = DEFAULT_ICON_SIZE, style, ...props }) {
    return (
        <BandSvg
            width={size}
            height={size}
            focusable="false"
            aria-hidden={props["aria-label"] ? undefined : true}
            style={{
                color: "currentColor",
                ...style,
            }}
            {...props}
        />
    );
}

export function DiscoverIcon({ size = DEFAULT_ICON_SIZE, style, ...props }) {
    return (
        <DiscoverSvg
            width={size}
            height={size}
            focusable="false"
            aria-hidden={props["aria-label"] ? undefined : true}
            style={{
                color: "currentColor",
                ...style,
            }}
            {...props}
        />
    );
}

export const HealthIcon = createIcon(
    <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75 9 17.25l6-10.5 4.5 6.75" />
);

export const BillingIcon = createIcon(
    <>
        <rect x="3.75" y="6.75" width="16.5" height="10.5" rx="2" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 10.25h16.5M7 14.25h4.25" />
    </>
);

export const NavigationIcons = {
    [HOME_TAB_ID]: HomeIcon,
    [FEED_TAB_ID]: FeedIcon,
    [FRIENDS_TAB_ID]: PeopleIcon,
    [CHAT_TAB_ID]: MessagesIcon,
    [BANDS_TAB_ID]: BandsIcon,
    [BILLING_TAB_ID]: BillingIcon,
    [DISCOVER_TAB_ID]: DiscoverIcon,
    [EVENTS_TAB_ID]: EventIcon,
    [VENUE_TAB_ID]: VenueIcon,
    [SYSTEM_HEALTH_TAB_ID]: HealthIcon,
};
